export default {
    submitSearchQuery: "Submit your search query",
    resetSearchQuery: "Reset the search query",
    cantFindMatches: "We can't find any results for",
    seeAllProducts: "See all products",
}
